import axiosInstance from "./axios.instance";
import {
  normalizeAssignedTo,
  validateAssignedTo,
  validateNote,
} from "../utils/ticketAssignmentUtils";
import { getSupportticketApiUrl } from "./supportticketBase";

export const assignSupportTicket = async (ticketId, assignedTo, note) => {
  const normalizedAssignedTo =
    assignedTo === null ? null : normalizeAssignedTo(assignedTo);
  const normalizedNote = String(note || "").trim();

  const assignedValidation = validateAssignedTo(normalizedAssignedTo);
  if (assignedValidation) {
    throw new Error(assignedValidation);
  }

  const noteValidation = validateNote(normalizedNote);
  if (noteValidation) {
    throw new Error(noteValidation);
  }

  const payload = {
    assignedTo: normalizedAssignedTo || null,
  };

  if (normalizedNote) {
    payload.note = normalizedNote;
  }

  try {
    const resp = await axiosInstance.put(
      getSupportticketApiUrl(`/admin/supportticket/${ticketId}/assign`),
      payload
    );
    return resp.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      const legacyResp = await axiosInstance.put(
        `/admin/company/supportTicket/${ticketId}/assign`,
        payload
      );
      return legacyResp.data;
    }

    const message =
      error?.response?.data?.message || error?.message || "Unable to assign ticket";
    throw new Error(message);
  }
};
